import { useState } from "react";
import Tooltip from "@mui/joy/Tooltip";
import Typography from "@mui/joy/Typography";
import Stack from "@mui/joy/Stack";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemDecorator from "@mui/joy/ListItemDecorator";


import getIcon from "utils/getIcon";
import { ScreenContainerTwoPotato } from "components/ScreenContainerPotato";
import { BACKGROUND_GRADIENT_CSS } from '../constants';
import Next from './PotatoNext';

import Lore from "components/Lore";
import Button from "@mui/joy/Button";

function LoreViewer({ slug, title, icon }: {slug: string, title: string, icon: string}) {
    const Icon = getIcon(icon);
    return (
        <Tooltip title="Click to learn more">
        <Stack>

        <Typography level="title-lg"
                   startDecorator={<Icon />}>
                {title}
                </Typography>
                <Stack alignItems="flex-start">
                <Lore slug={slug} showInfo={false} />
                </Stack>
            </Stack>
            </Tooltip>
    );
}

export default function PotatoWhatIsDayOnes({ onInView }: { onInView: (visibile: boolean, id: string) => boolean }) {

    const [viewingLore, setViewingLore] = useState('');
    const [viewingTitle, setViewingTitle] = useState('');
    const [viewingIcon, setViewingIcon] = useState('');
    const BackIcon = getIcon('ArrowBack');
    const Icon = getIcon(viewingIcon);

    function ListLink({ text, icon, loreSlug='' }: { text: string, icon: string, loreSlug?: string }) {
        const Icon = getIcon(icon);
        return (
            <ListItem
                className="clickable"
                sx={{ cursor: "pointer" }}
                onClick={() => {setViewingLore(loreSlug); setViewingTitle(text); setViewingIcon(icon)}}
            >
                <ListItemDecorator><Icon /></ListItemDecorator>
                <ListItemContent>{text}</ListItemContent>
            </ListItem>
        );
    }

    return (
        <ScreenContainerTwoPotato
            view="what-is-day-ones"
            onInView={onInView}
            reversed={true}
            window={

                <Stack
                    sx={{
                        opacity: 0.9,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundImage: BACKGROUND_GRADIENT_CSS,
                    }}
                >

                    <Typography
                        level="title-lg"
                        sx={{
                            backgroundImage: BACKGROUND_GRADIENT_CSS,
                            filter: "brightness(0)",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            // opacity: 0.75,

                            backgroundClip: "text",
                            textFillColor: "transparent;",
                            fontSize: { xs: "6rem", md: "5rem" },
                            textAlign: "center",
                            fontWeight: (viewingLore ? undefined : "bold"),
                            fontFamily: (viewingLore ? undefined : "'Oranienbaum', serif"),

                        }}
                >
                        {viewingLore ?
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Icon fontSize="xl4" />
                                {viewingTitle}
                                </Stack> :
                            <Stack>
                            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                    Day Ones
                                   </Stack>
                                   <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                                   <Typography sx={{ fontSize: '0.8rem', fontWeight: 'normal', fontFamily: 'sans-serif' }}>
                                   The new version of Fancy Hands.
                                   </Typography>
                                   </Stack>
                                   </Stack>

                }

                 </Typography>







                </Stack>
            }>

            { viewingLore &&
                <Stack>
                <LoreViewer slug={viewingLore} title={viewingTitle} icon={viewingIcon} />
                <Stack direction="row" spacing={1} alignItems="center">
                <Button size="sm" variant="plain"
                        onClick={() => setViewingLore('')}
                        startDecorator={<BackIcon />}>Show All
                </Button>
                </Stack>

                </Stack>
                }


                { !viewingLore &&
            <Stack pb={2} spacing={2}>
                <Typography>
                    Day Ones is the where you get more done.
                </Typography>
                <Typography level="title-lg" component="h3">

                                                                A brand new version of Fancy Hands
                </Typography>

                <Typography level="body-lg">
                    Everything you need. Built for the modern world.
                </Typography>


                    <Stack>
                        <Stack direction="row">
                            <List>
                            <ListLink icon="DayOnesNew" text="Modernized" loreSlug="feature/breakdown/modernized" />
                            <ListLink icon="DayOnesProject" text="Projects" loreSlug="feature/breakdown/projects" />
                                <ListLink icon="DayOnesPerformance" text="Performance" loreSlug="feature/breakdown/performance" />
                                <ListLink icon="DayOnesSecurity" text="Security" loreSlug="feature/breakdown/security" />

                                {/* <ListLink icon="DayOnesParcel" text="Parcel" loreSlug="feature/business/parcel" /> */}
                            </List>
                            <List>

                                <ListLink icon="DayOnesEmail" text="Email" loreSlug="feature/breakdown/email" />
                                <ListLink icon="DayOnesCalendar" text="Calendar" loreSlug="feature/breakdown/calendar" />
                                <ListLink icon="DayOnesPhone" text="Phone" loreSlug="feature/breakdown/phone" />

                            </List>

                        </Stack>
                        <Stack direction="row" justifyContent="center">
                            <Typography level="body-xs">
                                Click on a feature to learn more
                            </Typography>
                        </Stack>

                            </Stack>

                    <Stack sx={{
                        position: "absolute",
                        padding: 1,
                        bottom: 3,
                        left: 3
                    }} >
                        <Tooltip
                            arrow
                            title="Contact us for additional access.">
                            <Typography
                                level="body-xs"
                                sx={{ cursor: "pointer" }}
                            >
                                This site is in beta. Not every feature available to every user. Day Ones is the code name.
                            </Typography>
                        </Tooltip>
                        </Stack>

                </Stack>
                }

                    <Next nextId="starts-with-collabs" ks="How does it work?" />

        </ScreenContainerTwoPotato>
    );
}
